import { render } from "./InsuranceList.vue?vue&type=template&id=5fd5f522&scoped=true"
const script = {}

import "./InsuranceList.vue?vue&type=style&index=0&id=5fd5f522&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fd5f522"

export default script